import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../../config/constants';
import Loading from '../../components/Loading';
import useAsync from '../../../hooks/useAsync';
import './SumDataStruct.scss';
import { useNavigate } from 'react-router';
import { ConfirmContext } from '../../components/ConfirmModal';
import createIconImg from '../../../images/createIcon.png';
import editDSIcon from '../../../images/editDS.png';
import deleteDSIcon from '../../../images/deleteDS.png';
import CustomCheckbox from '../../components/CustomCheckbox';
import { useSelector } from 'react-redux';

function ShowSumDataStructure(props) {
    const { privilege } = useSelector((state) => state.session);
    const navigate = useNavigate();
    const { confirm } = useContext(ConfirmContext);
    const [result, setResult] = useState([]);
    async function getSumDataStructs() {
        const response = await axios.post(`${API_URL}/monitoring-manage/getSumDataStructs`);
        // return response.data;
        setResult([...response.data]);
    }

    const onClickEditBtn = (e, idNo) => {
        e.preventDefault();
        navigate(`/home/dataStructure/sumData/edit/${idNo}`);
    }

    const onClickDeleteBtn = async (e, selectedData) => {
        e.preventDefault();
        const result = await confirm(`${selectedData.name}를(을) 삭제하시겠습니까?`, '삭제', '취소');
        if (result) {
            await axios.post(`${API_URL}/monitoring-manage/deleteSumDataStruct`, { sumDsId: selectedData.sumDsId }).then(res => {
                if (res.data.success) {
                    navigate(0);
                }
            })
        }
    }

    // const onCheck = async (e, dsIdx, outerIdx, innerIdx, idNo) => {
    //     const newValView = [...]
    //     await axios.post(`${API_URL}/monitoring-manage/updateSumDataView`, { idNo: idNo, valView: JSON.parse(e.target.value) });
    // };


    useEffect(() => {
        getSumDataStructs();
    }, [])

    // const state = useAsync(getSumDataStructs);
    // const { loading, error, data: result } = state;
    // if (loading) return <div className='contentArea' style={{ height: '100%' }}><Loading /></div>
    // if (error) {
    //     console.log(error)
    //     return <div className='contentArea'>페이지를 나타낼 수 없습니다.</div>
    // }
    // if (!result) return <div>실패</div>;

    return (
        <div className='showSumDataStructs'>
            <p className='path'>데이터 구조 관리<span className='below'>{'>'}</span>요약 데이터 구조</p>
            <h2 className='pageTitle'>요약 데이터 구조</h2>

            <div className='tblArea'>
                <ul className='sumDsTbl dataTable'>
                    <li className='thRow'>
                        <ul className='tr'>
                            <li className='name'>공정요약 이름</li>
                            <li className='grpNo'>데이터 그룹 수</li>
                            <li className='grpSeq'>순번</li>
                            <li className='grpName'>데이터 그룹 이름</li>
                            <li className='dataClass'>분류</li>
                            <li className='indexNo'>세부 데이터 수</li>
                            <li className='indexName'>세부 데이터 이름</li>
                            <li className='indexType'>데이터 유형</li>
                            <li className='indexDim'>단위</li>
                            <li className='indexComment'>세부 데이터 코멘트</li>
                            <li className='isCalc'>계산 데이터 여부</li>
                            <li className='calcEq'>계산식</li>
                            <li className='valView'>값 표시</li>
                            <li className='variView'>편차 표시</li>
                            <li className='applyToOkNg'>판정 적용</li>
                            <li className='okNgView'>판정 표시</li>
                            <li className='organization'>소속</li>
                            <li className='owner'>담당자</li>
                            <li className='comment'>코멘트</li>
                            <li className='edit'>수정</li>
                            <li className='delete'>삭제</li>
                        </ul>
                    </li>
                    {
                        result.map((item, index) => {
                            const wholeRowAmount = item?.indexNo.reduce((prev, cur) => prev + cur, 0);
                            return (
                                <li className='tdRow' key={`sumDsId${item.sumDsId}`}>
                                    <ul className='tr'>
                                        <li className='name td' style={{ height: `${wholeRowAmount * 30}px` }}><div className='divInTd'><p>{item.name}</p></div></li>
                                        <li className='grpNo td' style={{ height: `${wholeRowAmount * 30}px` }}><div className='divInTd'><p>{item.grpNo}</p></div></li>
                                        <li className='grpSeq'>
                                            <ul>
                                                {
                                                    item.grpName.map((name, arrIdx) => {
                                                        const idxAmt = item.indexNo[arrIdx];
                                                        return (
                                                            <li className='grpSeqInner td' key={`grpSeqInner_${arrIdx}`} style={{ height: `${idxAmt * 30}px` }}>
                                                                <div className='divInTd'><p>{arrIdx + 1}</p></div>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </li>
                                        <li className='grpName'>
                                            <ul>
                                                {
                                                    item.grpName.map((name, arrIdx) => {
                                                        const idxAmt = item.indexNo[arrIdx];
                                                        return (
                                                            <li className='grpNameInner td' key={`grpNameInner_${arrIdx}`} style={{ height: `${idxAmt * 30}px` }}>
                                                                <div className='divInTd'><p>{name}</p></div>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </li>
                                        <li className='dataClass'>
                                            <ul>
                                                {
                                                    item.dataClass.map((cl, arrIdx) => {
                                                        const idxAmt = item.indexNo[arrIdx];
                                                        return (
                                                            <li className='dataClassInner td' key={`dataClassInner_${arrIdx}`} style={{ height: `${idxAmt * 30}px` }}>
                                                                <div className='divInTd'><p>{cl}</p></div>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </li>
                                        <li className='indexNo'>
                                            <ul>
                                                {
                                                    item.indexNo.map((indexNo, arrIdx) => (<li className='indexNoInner td' key={`indexNoInner_${arrIdx}`} style={{ height: `${indexNo * 30}px` }}>
                                                        <div className='divInTd'><p>{indexNo}</p></div>
                                                    </li>))
                                                }
                                            </ul>
                                        </li>
                                        <li className='indexName'>{
                                            item.indexName.map((secondArr, arrIdx) => (<ul key={`indexNameUl_${arrIdx}`}>
                                                {
                                                    secondArr.map((indexName, innerIdx) => (<li className='indexNameInner td' key={`indexNameInner_${innerIdx}`}><div className='divInTd'><p>{indexName}</p></div></li>)
                                                    )
                                                }
                                            </ul>))
                                        }</li>
                                        <li className='indexType'>{
                                            item.indexType.map((secondArr, arrIdx) => (<ul key={`indexTypeUl_${arrIdx}`}>
                                                {
                                                    secondArr.map((indexType, innerIdx) => (<li className='indexTypeInner td' key={`indexTypeInner_${innerIdx}`}><div className='divInTd'><p>{indexType}</p></div></li>)
                                                    )
                                                }
                                            </ul>))
                                        }</li>
                                        <li className='indexDim'>{
                                            item.indexDim.map((secondArr, arrIdx) => (<ul key={`indexDimUl_${arrIdx}`}>
                                                {
                                                    secondArr.map((indexDim, innerIdx) => (<li className='indexDimInner td' key={`indexDimInner_${innerIdx}`}><div className='divInTd'><p>{indexDim ?? '-'}</p></div></li>)
                                                    )
                                                }
                                            </ul>))
                                        }</li>
                                        <li className='indexComment'>{
                                            item.indexComment.map((secondArr, arrIdx) => (<ul key={`indexCommentUl_${arrIdx}`}>
                                                {
                                                    secondArr.map((indexComment, innerIdx) => (<li className='indexCommentInner td' key={`indexCommentInner_${innerIdx}`}><div className='divInTd'><p>{indexComment ?? '-'}</p></div></li>)
                                                    )
                                                }
                                            </ul>))
                                        }</li>

                                        <li className='isCalc'>
                                            {
                                                item.isCalc.map((secondArr, arrIdx) => (<ul key={`indexTypeUl_${arrIdx}`}>
                                                    {
                                                        secondArr.map((isS, innerIdx) => (<li className='indexTypeInner td' key={`indexTypeInner_${innerIdx}`}><div className='divInTd'><p>{isS ? 'O' : 'X'}</p></div></li>)
                                                        )
                                                    }
                                                </ul>))
                                            }
                                        </li>
                                        <li className='calcEq'>
                                            {
                                                item.calcEq.map((secondArr, arrIdx) => (<ul key={`indexTypeUl_${arrIdx}`}>
                                                    {
                                                        secondArr.map((calcEq, innerIdx) => (<li className='indexTypeInner td' key={`indexTypeInner_${innerIdx}`}><div className='divInTd'><p>{calcEq ?? '-'}</p></div></li>)
                                                        )
                                                    }
                                                </ul>))
                                            }
                                        </li>

                                        <li className='valView'>
                                            {
                                                item["valView"].map((secondArr, arrIdx) => (<ul key={`valView_${arrIdx}`}>
                                                    {
                                                        secondArr.map((valView, idx) => {
                                                            return (
                                                                <li className='valViewInner td' key={`valView_${idx}`}>
                                                                    <div className='divInTd'>
                                                                        <CustomCheckbox
                                                                            checked={valView}
                                                                            id={`valView_${index}_${arrIdx}_${idx}`}
                                                                            value={!valView}
                                                                            onChange={async e => {
                                                                                const copiedData = [...result];
                                                                                const newValView = [...item["valView"]];
                                                                                newValView[arrIdx][idx] = JSON.parse(e.target.value);
                                                                                copiedData[index]["valView"] = newValView;
                                                                                await axios.post(`${API_URL}/monitoring-manage/updateSumDataView`, { sumDsId: item["sumDsId"], valView: newValView }).then(res => {
                                                                                    if (res.data.success) {
                                                                                        setResult(prev => ([...copiedData]))
                                                                                    }
                                                                                });
                                                                            }}
                                                                            disabled={!privilege?.sumDataView.edit}
                                                                        />
                                                                    </div>
                                                                </li>
                                                            );
                                                        })
                                                    }
                                                </ul>))
                                            }
                                        </li>
                                        <li className='variView'>
                                            {
                                                item["variView"].map((secondArr, arrIdx) => (<ul key={`variView_${arrIdx}`}>
                                                    {
                                                        secondArr.map((variView, idx) => {
                                                            return (
                                                                <li className='variViewInner td' key={`variView_${idx}`}>
                                                                    <div className='divInTd'>
                                                                        <CustomCheckbox
                                                                            checked={variView}
                                                                            id={`variView_${index}_${arrIdx}_${idx}`}
                                                                            value={!variView}
                                                                            onChange={async e => {
                                                                                const copiedData = [...result];
                                                                                const newVariView = [...item["variView"]];
                                                                                newVariView[arrIdx][idx] = JSON.parse(e.target.value);
                                                                                copiedData[index]["variView"] = newVariView;
                                                                                await axios.post(`${API_URL}/monitoring-manage/updateSumDataView`, { sumDsId: item["sumDsId"], variView: newVariView }).then(res => {
                                                                                    if (res.data.success) {
                                                                                        setResult(prev => ([...copiedData]))
                                                                                    }
                                                                                });
                                                                            }}
                                                                            disabled={!privilege?.sumDataView.edit || !item["valView"][arrIdx][idx]}
                                                                        />
                                                                    </div>
                                                                </li>
                                                            );
                                                        })
                                                    }
                                                </ul>))
                                            }
                                        </li>
                                        <li className='applyToOkNg'>
                                            {
                                                item["applyToOkNg"].map((secondArr, arrIdx) => (<ul key={`applyToOkNg_${arrIdx}`}>
                                                    {
                                                        secondArr.map((applyToOkNg, idx) => {
                                                            return (
                                                                <li className='applyToOkNgInner td' key={`applyToOkNg_${idx}`}>
                                                                    <div className='divInTd'>
                                                                        <CustomCheckbox
                                                                            checked={applyToOkNg}
                                                                            id={`applyToOkNg_${index}_${arrIdx}_${idx}`}
                                                                            value={!applyToOkNg}
                                                                            onChange={async e => {
                                                                                const copiedData = [...result];
                                                                                const newApplyToOkNg = [...item["applyToOkNg"]];
                                                                                newApplyToOkNg[arrIdx][idx] = JSON.parse(e.target.value);
                                                                                copiedData[index]["applyToOkNg"] = newApplyToOkNg;
                                                                                await axios.post(`${API_URL}/monitoring-manage/updateSumDataView`, { sumDsId: item["sumDsId"], applyToOkNg: newApplyToOkNg }).then(res => {
                                                                                    if (res.data.success) {
                                                                                        setResult(prev => ([...copiedData]))
                                                                                    }
                                                                                });
                                                                            }}
                                                                            disabled={!privilege?.sumDataView.edit}
                                                                        />
                                                                    </div>
                                                                </li>
                                                            );
                                                        })
                                                    }
                                                </ul>))
                                            }
                                        </li>
                                        <li className='okNgView'>
                                            <ul>
                                                {
                                                    item.okNgView.map((okNgView, arrIdx) => {
                                                        const idxAmt = item.indexNo[arrIdx];

                                                        return (
                                                            <li className='okNgViewInner td' key={`okNgView_${arrIdx}`} style={{ height: `${idxAmt * 30}px` }}>
                                                                <div className='divInTd'>
                                                                    <CustomCheckbox
                                                                        checked={okNgView}
                                                                        id={`okNgView_${index}_${arrIdx}`}
                                                                        value={!okNgView}
                                                                        onChange={async e => {
                                                                            const copiedData = [...result];
                                                                            const newOkNgView = [...item["okNgView"]];
                                                                            newOkNgView[arrIdx] = JSON.parse(e.target.value);
                                                                            copiedData[index]["okNgView"] = newOkNgView;
                                                                            await axios.post(`${API_URL}/monitoring-manage/updateSumDataView`, { sumDsId: item["sumDsId"], okNgView: newOkNgView }).then(res => {
                                                                                if (res.data.success) {
                                                                                    setResult(prev => ([...copiedData]))
                                                                                }
                                                                            });
                                                                        }}
                                                                        disabled={!privilege?.sumDataView.edit || item.valView[arrIdx].filter(el => el === true).length === 0}
                                                                    />
                                                                </div>
                                                            </li>
                                                        );
                                                    })
                                                }
                                            </ul>
                                        </li>

                                        <li className='organization td' style={{ height: `${wholeRowAmount * 30}px` }}><div className='divInTd'><p>{item["Organization.name"]}</p></div></li>
                                        <li className='owner td' style={{ height: `${wholeRowAmount * 30}px` }}><div className='divInTd'>
                                            <p >
                                                {
                                                    item.owner.map((el, idx, arr) => {
                                                        if (idx < arr.length - 1) {
                                                            return (
                                                                <React.Fragment key={`indexUserOwner_cont_${idx}`}>
                                                                    <span key={`indexUserOwner_${idx}`}>{el},</span>
                                                                    <br key={`indexUserOwner_br_${idx}`} />
                                                                </React.Fragment>
                                                            )
                                                        } else {
                                                            return (
                                                                <span key={`indexUserOwner_${idx}`}>{el}</span>
                                                            )
                                                        }
                                                    })
                                                }
                                            </p>
                                        </div></li>
                                        <li className='comment td' style={{ height: `${wholeRowAmount * 30}px` }}><div className='divInTd'>{item.comment ?? '-'}</div></li>
                                        <li className='edit td' style={{ height: `${wholeRowAmount * 30}px` }}>
                                            <div className='divInTd'>
                                                <button className='editBtn' onClick={e => onClickEditBtn(e, item.sumDsId)}>
                                                    <img src={editDSIcon} alt="수정" />
                                                </button>
                                            </div>
                                        </li>
                                        <li className='delete td' style={{ height: `${wholeRowAmount * 30}px` }}>
                                            <div className='divInTd'>
                                                <button className='deleteBtn' onClick={e => onClickDeleteBtn(e, item)}>
                                                    <img src={deleteDSIcon} alt="삭제" />
                                                </button>
                                            </div>
                                        </li>
                                    </ul>
                                </li>
                            )
                        })
                    }
                </ul>
            </div>
            <div className='btnsArea'>
                <button className='createBtn' onClick={e => {
                    e.preventDefault();
                    navigate('/home/dataStructure/sumData/create')
                }} >추가<img src={createIconImg} alt={"추가"} /></button>
            </div>
        </div>
    );
}

export default ShowSumDataStructure;
